export default {"src":"/org/_next/static/media/arrow-up-right.9725534b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};